define('home/views/ProfileCardFavoriteView',[
    'home/views/common/ActivityCardView',
    'home/mixins/asProfileCard',

    'home/templates/profileCardFavorite',
], function (
    ActivityCardView,
    asProfileCard,

    profileCardFavoriteTemplate
) {
    'use strict';

    var parent = ActivityCardView;


    var ProfileCardFavoriteView = parent.extend({
        className: 'card card-profile card-profile-favorite',

        template: profileCardFavoriteTemplate,
    });

    asProfileCard.call(ProfileCardFavoriteView.prototype);
    return ProfileCardFavoriteView;
});

